import random from "./random";

export default {
	generate(length: number, chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"): string {
		if (!Number.isInteger(length)) {
			throw new Error(`length: ${length} is not an integer`);
		}
		return `YV_${new Array(length)
			.fill(null)
			.map((_) => random.item(chars))
			.join("")}`;
	},
	generateKey() {
		const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

		const randomString = new Array(17)
			.fill(null)
			.map((_) => random.item(chars))
			.join("");
		return `VP_${randomString}`;
	},
};
